// extracted by mini-css-extract-plugin
module.exports = {"container":"Pages__container___2vUPz","pageForm":"Pages__pageForm___2uPms"};